module.exports = __webpack_public_path__ + "static/media/team-joan.eae05ede.jpg";